{
	"name": "@memorang/features",
	"version": "1.0.87",
	"license": "MIT",
	"scripts": {
		"typecheck": "tsc --noEmit --pretty",
		"test": "vitest run",
		"test:watch": "vitest"
	},
	"dependencies": {
		"@memorang/constants": "workspace:*",
		"@memorang/helpers": "workspace:*",
		"@memorang/ui": "workspace:*"
	},
	"peerDependencies": {
		"@gorhom/bottom-sheet": "*",
		"@react-native-community/hooks": "^3.0.0",
		"@tanstack/react-query": "^5.0.0",
		"axios": "catalog:",
		"expo-audio": "*",
		"expo-router": "~55.0.12",
		"markdown-it": "^13.0.1",
		"markdown-it-sub": "^1.0.0",
		"markdown-it-sup": "^1.0.0",
		"react": ">=18",
		"react-fast-compare": "^3.2.2",
		"react-native": ">=0.74",
		"react-native-easy-content-loader": "^0.3.2",
		"react-native-markdown-renderer": "^4.1.1",
		"react-native-math-view": "^3.9.5",
		"react-native-paper": "^5.0.0",
		"react-native-reanimated": "*",
		"react-native-safe-area-context": "*",
		"react-native-worklets": "~0.7.2",
		"zod": "^4.3.6"
	},
	"devDependencies": {
		"@memorang/typescript": "workspace:*",
		"@types/react": "catalog:",
		"typescript": "catalog:",
		"vitest": "catalog:"
	}
}
